import { render, staticRenderFns } from "./ListElvAddress.vue?vue&type=template&id=775e2bb9&scoped=true&"
import script from "./ListElvAddress.vue?vue&type=script&lang=js&"
export * from "./ListElvAddress.vue?vue&type=script&lang=js&"
import style0 from "@/styles/table-styles.css?vue&type=style&index=0&id=775e2bb9&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "775e2bb9",
  null
  
)

export default component.exports